import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

import { fontBase64 } from './fontBase64';

if (pdfFonts.pdfMake !== undefined) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else {
  pdfMake.vfs = pdfFonts;
}

Object.assign(pdfMake.vfs, fontBase64);

pdfMake.addFonts({
  PlusJakartaSans: {
    normal: 'PlusJakartaSans-Regular.ttf',
    bold: 'PlusJakartaSans-Bold.ttf',
    italics: 'PlusJakartaSans-Regular.ttf',
    bolditalics: 'PlusJakartaSans-Bold.ttf',
    light: 'PlusJakartaSans-Light.ttf',
    medium: 'PlusJakartaSans-Medium.ttf',
    semibold: 'PlusJakartaSans-SemiBold.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
});
